module.exports = __webpack_public_path__ + "static/media/noun-earth-1792107-142350.f514c72f.svg";